import { usePermissions } from "@/shared/composables/usePermissions";
export function useOpinkPermissions() {
    const { canAdminOpink } = usePermissions();
    return { canWriteConsent: canAdminOpink };
}
